import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VideoThumbnailCaptureService {

  blobToJpegFile(blob: Blob, fileName: string): File {
    return new File([blob], fileName, { type: 'image/jpeg' });
  }
}
